var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('b-modal',{attrs:{"id":"modal-cgu","title":_vm.$t(
        'Conditions générales d\'utilisation de la plateforme Ooftop - Dernière mise à jour : 2 janvier 2023'
      ),"hide-footer":""}},[_c('CGU')],1),_c('b-modal',{attrs:{"id":"modal-cookies","title":_vm.$t(
        'Politique de cookies de la solution de valorisation de biens immobiliers - Mis à jour le 2/01/2023'
      ),"hide-footer":""}},[_c('COOKIES')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }